import { useEffect, useState } from 'react';
import useLocale from './localeHook';
import { getLocalizedUrl } from '../url';
import { GLOBAL_NAV_CART, GLOBAL_NAV_FAVORITES, NIKE_CUSTOM_EVENT } from '../../constants';
import useFeatureFlags from './featureFlagsHook';

/**
 * Hook that handles the cart and favorites state
 * @returns {{
 * isCartEnabled: boolean,
 * isFavoritesEnabled: boolean,
 * itemsInCart: number,
 * cartUrl: string,
 * favsUrl: string
 * }}
 */
export function useCartAndFavorites() {
  const locale = useLocale();
  const [itemsInCart, setItemsInCart] = useState(0);
  const [cartUrl, setCartUrl] = useState(getLocalizedUrl('cart')(locale));
  const [favsUrl, setFavsUrl] = useState(getLocalizedUrl('favorites')(locale));
  const isCartEnabled = useFeatureFlags(GLOBAL_NAV_CART);
  const isFavoritesEnabled = useFeatureFlags(GLOBAL_NAV_FAVORITES);

  useEffect(() => {
    const initNikeShop = () => {
      const { cartHref, favoritesHref } = window.NikeShop.get();
      setCartUrl(cartHref);
      setFavsUrl(favoritesHref);
    };

    /**
     * Handler triggered from nike shop listener below that updates the cart count state
     * @param {object} event
     * @param {object} event.detail
     * @param {number} event.detail.cartCount
     */
    const updateCartCount = ({ detail: { cartCount } }) => setItemsInCart(cartCount);

    window.addEventListener(NIKE_CUSTOM_EVENT.UPDATED_SHARED_SHOP_DATA, initNikeShop);
    window.addEventListener(NIKE_CUSTOM_EVENT.UPDATED_CART_COUNT, updateCartCount);

    return () => {
      window.removeEventListener(NIKE_CUSTOM_EVENT.UPDATED_SHARED_SHOP_DATA, initNikeShop);
      window.removeEventListener(NIKE_CUSTOM_EVENT.UPDATED_CART_COUNT, updateCartCount);
    };
  }, []);

  return { isCartEnabled, isFavoritesEnabled, itemsInCart, cartUrl, favsUrl };
}
